import Globals from '@/config/Globals';
//
export default class APIDispatchLists {
  constructor(API) {
    this.api = API;
  }

  async getAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_DispatchLists;
    return await req.exec();
  }

  async create(dispatchListObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = Globals.APIPath_DispatchList + Globals.URL_NewIndentifier;
    req.body = { ...dispatchListObj };
    return await req.exec();
  }

  async update(dispatchListObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = Globals.APIPath_DispatchList + dispatchListObj.id;
    delete dispatchListObj.id;
    req.body = { ...dispatchListObj };
    return await req.exec();
  }

  async remove(dispatchListID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = Globals.APIPath_DispatchList + dispatchListID;
    return await req.exec();
  }
}
